/**
 * SkillVersions - Sag panel Versions tab
 */
import { Check, ChevronDown, ChevronUp, Clock } from 'lucide-react'
import { useState } from 'react'
import type { VersionEntry } from '../hooks/useSkills'

interface Props {
  currentVersion: string
  currentChangelog: string
  versions: VersionEntry[]
  accent: string
  fullWidth?: boolean
}

export default function SkillVersions({ currentVersion, currentChangelog, versions, accent, fullWidth }: Props) {
  const [expanded, setExpanded] = useState(false)

  return (
    <div style={{ padding: fullWidth ? '0' : '14px', maxHeight: fullWidth ? 'none' : '580px', overflowY: fullWidth ? 'visible' : 'auto' }}>
      {/* Current */}
      <div style={{ padding:'14px', borderRadius:'10px', marginBottom:'10px', background:`${accent}10`, border:`1px solid ${accent}28` }}>
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:'5px' }}>
          <span style={{ fontSize:'14px', fontWeight:700, color:accent }}>v{currentVersion}</span>
          <span style={{ fontSize:'9px', fontWeight:700, padding:'2px 7px', borderRadius:'10px', background:`${accent}20`, color:accent }}>Current</span>
        </div>
        {currentChangelog && <p style={{ fontSize:'12px', color:'var(--text-secondary)', margin:0, lineHeight:'1.5' }}>{currentChangelog}</p>}
      </div>

      {/* History */}
      {versions.length > 0 && (
        <>
          <button
            onClick={() => setExpanded(v=>!v)}
            style={{ width:'100%', padding:'7px', borderRadius:'8px', fontSize:'11px', background:'none', border:'1px solid var(--border-color)', color:'var(--text-secondary)', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', gap:'4px', marginBottom:'8px' }}
          >
            {expanded ? <><ChevronUp size={11}/> Hide history</> : <><ChevronDown size={11}/> {versions.length} older versions</>}
          </button>

          {expanded && versions.map((v, i) => (
            <div key={i} style={{ padding:'12px', borderRadius:'8px', marginBottom:'7px', background:'rgba(255,255,255,.03)', border:'1px solid rgba(255,255,255,.07)' }}>
              <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:'4px' }}>
                <span style={{ fontSize:'12px', fontWeight:600 }}>v{v.version}</span>
                <span style={{ fontSize:'10px', color:'var(--text-secondary)' }}>{v.date}</span>
              </div>
              <p style={{ fontSize:'11px', color:'var(--text-secondary)', margin:0, lineHeight:'1.5' }}>{v.changelog}</p>
              {v.issues_fixed?.length > 0 && (
                <div style={{ marginTop:'5px', display:'flex', flexDirection:'column', gap:'3px' }}>
                  {v.issues_fixed.map((f,j) => (
                    <span key={j} style={{ fontSize:'10px', color:'#22c55e', display:'flex', alignItems:'center', gap:'3px' }}>
                      <Check size={9}/> {f}
                    </span>
                  ))}
                </div>
              )}
            </div>
          ))}
        </>
      )}

      {versions.length === 0 && !currentChangelog && (
        <div style={{ textAlign:'center', padding:'24px', color:'var(--text-secondary)', fontSize:'12px' }}>
          <Clock size={22} style={{ margin:'0 auto 8px', display:'block', opacity:.35 }}/>
          No version history yet.
        </div>
      )}
    </div>
  )
}
